import { CATALOG } from '../../music/catalog';
import { ScoreCard } from '../components/ScoreCard';
import { useProgress } from '../hooks/stores';
import { href } from '../router';

export type CatalogFilter = 'tout' | 'exercices' | 'morceaux';

export function CatalogPage({ filter = 'tout' }: { filter?: CatalogFilter }) {
  const progress = useProgress();
  const exercises = CATALOG.filter((s) => s.kind === 'exercise');
  const pieces = CATALOG.filter((s) => s.kind === 'piece');
  const showExercises = filter !== 'morceaux';
  const showPieces = filter !== 'exercices';
  return (
    <main className="page">
      <header className="page-head">
        <h1>Catalogue</h1>
        <p className="lede">Des exercices courts pour poser les mains, puis des morceaux à jouer en entier.</p>
        <details className="details">
          <summary>Deux façons de travailler</summary>
          <p>Mode attente : la lecture attend chacune de vos notes. Tempo imposé : le morceau défile, vous suivez ; c’est ce mode qui valide un exercice, sur un instrument.</p>
        </details>
        <div className="seg" role="group" aria-label="Filtre du catalogue">
          {(
            [
              ['tout', 'Tout'],
              ['exercices', 'Exercices'],
              ['morceaux', 'Morceaux'],
            ] as [CatalogFilter, string][]
          ).map(([key, label]) => (
            <a key={key} className={filter === key ? 'seg-btn on' : 'seg-btn'} href={key === 'tout' ? href('catalogue') : href('catalogue', key)}>
              {label}
            </a>
          ))}
        </div>
      </header>
      {showExercises && (
        <section>
          <h2>Exercices</h2>
          <div className="card-grid">
            {exercises.map((s) => (
              <ScoreCard key={s.id} score={s} progress={progress.scores[s.id]} />
            ))}
          </div>
        </section>
      )}
      {showPieces && (
        <section>
          <h2>Morceaux</h2>
          <p className="muted">Sans cours obligatoire : ouvrez un morceau et jouez. Le catalogue s’élargira par étapes.</p>
          <div className="card-grid">
            {pieces.map((s) => (
              <ScoreCard key={s.id} score={s} progress={progress.scores[s.id]} />
            ))}
          </div>
        </section>
      )}
      <p className="muted">Niveau de ● (découverte) à ●●●●● (expert). Doigtés indicatifs, à relire par un professeur.</p>
    </main>
  );
}
